import React, { useState } from 'react'

import { Logo } from '@/assets/images/logo'

import { Flex } from '../common/Box'
import { SilkscreenText } from '../common/Text'
import { Menu } from '../svgr'
import { Close } from '../svgr/common'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger
} from '../ui/drawer'

import Contacts from './Contacts'
import Navs from './Navs'

const MenuDrawer: React.FC = () => {
  const [open, setOpen] = useState(false)

  return (
    <Drawer
      direction="top"
      handleOnly
      open={open}
      onOpenChange={setOpen}
      noBodyStyles
    >
      <DrawerTrigger>
        <Flex className="items-center">
          <Menu className="h-8 w-8" />
          <img src={Logo} className="ml-1 size-6" alt="terminus logo" />
          <SilkscreenText className="hidden xs:block xs:text-sm sm:text-base">
            TERMINUS
          </SilkscreenText>
        </Flex>
      </DrawerTrigger>
      <DrawerContent className="bottom-auto left-auto top-0 mt-0 w-full !rounded-none border-none bg-secondary p-4 [&>_div:first-of-type]:hidden">
        <DrawerHeader className="p-0 pb-2">
          <DrawerTitle>
            <Close onClick={() => setOpen(false)} className="h-8 w-8 p-2" />
          </DrawerTitle>
        </DrawerHeader>
        <Navs onNavigate={() => setOpen(false)} />
        <Contacts />
      </DrawerContent>
    </Drawer>
  )
}

export default MenuDrawer
